import qrcodescan from './qrcodescan'

export default {
  qrcodescan
}



// WEBPACK FOOTER //
// ./src/components/QrcodeScan/index.js